{
  "title": "No se pudo completar tu registro",
  "message": "Tu identificación no pudo ser validada"
}
